import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IpServiceService {

  constructor(private http: HttpClient) { }

  public getIPAddress() {
     return this.http.get(environment.IPAddressURL, { headers: { 'IgnoreInterceptor': '' } });
  }
}
